import { createSelector } from 'reselect';
import { getUserData } from '../selectors/user';

export const getPage = createSelector([getUserData], userData => {
    return {
        partnerName: userData.company_display_name,
    };
});
